import React, { Component } from 'react';
import ServiceProviderPermissions from './serviceProviderPermissions';

export default class PermissionItemContainer extends Component {

    render() {
  
        console.log('test');
        console.log(this.props);
        
        const { data } = this.props;

        return (
            <div>
                {
                    data.map(item => {

                        return <div
                                    key={item.id}
                                >
                                    <ServiceProviderPermissions
                                        data={item}
                                    />
                                </div>;
                    })
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/roles/editRole/permissionsItem/index.jsx